import { use } from 'react';

import { cn } from '@/lib/cn';

import { FlowContext } from '.';

type ProgressProps = {
  label?: string;
};

export const Progress = ({ label }: ProgressProps) => {
  const { currentStep, steps } = use(FlowContext);
  const filteredSteps = steps.filter(step => !step.untraceable);

  return (
    <div>
      {label && (
        <p className='mb-2 text-xs text-(--uizz-antd-color-text-tertiary)'>{`${label} — etapa ${(currentStep?.index ?? 0) + 1} de ${filteredSteps.length}`}</p>
      )}

      <div className='mb-10 flex gap-2'>
        {Array.from({ length: filteredSteps.length }).map((_, index) => (
          <span
            key={index}
            className={cn(
              'flex h-1 flex-1 rounded-full',
              currentStep?.index !== undefined && index <= currentStep.index
                ? 'bg-(--uizz-antd-color-primary)'
                : 'bg-(--uizz-antd-color-split)'
            )}
          />
        ))}
      </div>
    </div>
  );
};
